import Shader from './Shader';
import * as Uniform from '../Uniform';
import FRAG_CIRCLE from './Fragment/circle.frag';

export default class CircleShader extends Shader {
	public u_documentSize:Uniform.Uniform2f;
	public u_inputSize:Uniform.Uniform2f;
	public u_translation:Uniform.Uniform2f = new Uniform.Uniform2f(0.0, 0.0);
	public u_radius:Uniform.Uniform1f = new Uniform.Uniform1f(1.0);
	public u_color:Uniform.Uniform4f = new Uniform.Uniform4f(1.0,1.0,1.0,1.0);

	public frag = ():string => FRAG_CIRCLE;
}